import styled from "styled-components";
import { Heading2 } from "../../../components";
import { colors } from "../../../consts";

export const GridWrapper = styled.div`
  display: grid;
  width: 100%;
  margin-top: 16px;
  gap: 16px;

  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
`;

export const GridItem = styled.div`
  grid-column: ${(props) => props?.gridColumn && props?.gridColumn};
`;


export const MetricMainValue = styled(Heading2)`
  font-family: Plus Jakarta Sans, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 800;
  line-height: 32px;
  color: ${colors.RAISIN_100};
  
  margin-bottom: 16px;
`;